// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"libs_monitoring_src_lib_pages_executions_workflow-execution_component_ts":"482676e68bba44a9","libs_monitoring_src_lib_pages_history_workflow-history_component_ts":"78e43ec57e22304f","node_modules_angular_animations_fesm2022_browser_mjs":"a2f9fbb2ed2b77a0"}[chunkId] + ".js";
};